module.exports = __webpack_public_path__ + "static/media/fries.b0cde32f.png";